import { type FC } from "react";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PeopleIcon from "@mui/icons-material/People";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { AnalyticsMetrics } from "@/partner/shared/components/AnalyticsMetrics";
import { formatNumber } from "@/shared/utils/formatNumber";
import { useAnalyticsUsersMetricsQuery } from "@/partner/entities/analytics";

export const AnalyticsUsersMetrics: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsUsersMetricsQuery({
    fetchPolicy: "no-cache",
    variables: { filter: filter as never },
  });

  const metrics = [
    {
      icon: PersonAddIcon,
      label: t("analytics.users.metricsNewUsers"),
      value: formatNumber(data?.analyticsUsers.newUsers ?? 0),
    },
    {
      icon: PeopleIcon,
      label: t("analytics.users.metricsTotalUsers"),
      value: formatNumber(data?.analyticsUsers.totalUsers ?? 0),
    },
  ];

  return (
    <AnalyticsMetrics
      metrics={metrics}
      loading={loading}
      error={error}
      xs={12}
      md={6}
    />
  );
};
